var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdres(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 35,
    viewBox: "0 0 30 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2878 18.9495C24.8034 17.4506 25.1111 15.9192 25.1111 14.4002C25.1111 11.1114 23.8937 7.9574 21.7266 5.63192C19.5595 3.30644 16.6203 2 13.5556 2C10.4908 2 7.55163 3.30644 5.38454 5.63192C3.21746 7.9574 2 11.1114 2 14.4002C2 22.1394 10.0008 30.1995 12.6874 32.6888C12.9377 32.8908 13.2424 33 13.5556 33C13.8687 33 14.1734 32.8908 14.4237 32.6888C14.821 32.3198 15.2125 31.9436 15.598 31.5604M19.3333 26.8003L22.2222 29.9003L28 23.7003M17.8889 14.4002C17.8889 16.9683 15.9488 19.0502 13.5556 19.0502C11.1623 19.0502 9.22222 16.9683 9.22222 14.4002C9.22222 11.832 11.1623 9.7501 13.5556 9.7501C15.9488 9.7501 17.8889 11.832 17.8889 14.4002Z",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdres);
export default __webpack_public_path__ + "static/media/Adres.461678a007107407c91533a76f66ca6e.svg";
export { ForwardRef as ReactComponent };